<script setup>
import Switch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  label: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div
    class="flex items-start justify-between gap-4 rounded-lg border border-n-weak bg-n-solid-1 p-4"
  >
    <div class="min-w-0 space-y-1">
      <p class="text-sm font-medium text-n-slate-12">
        {{ label }}
      </p>

      <p v-if="description" class="text-sm leading-6 text-n-slate-11">
        {{ description }}
      </p>
    </div>

    <Switch
      class="flex-shrink-0"
      :model-value="modelValue"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </div>
</template>
